export default "__VITE_ASSET__uhnq7glZ__"